import { UIText2 } from '@cian/ui-kit';
import { IconMapWalk16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './styles.css';

export const WalkWayMinutes: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div className={styles['container']}>
      <IconMapWalk16 display="block" color="icon-secondary-default" />
      <UIText2 color="text-secondary-default">{children}</UIText2>
    </div>
  );
};
